// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1 1;
}

.card-topview {
    display: flex;
    flex-direction: row;
    padding-bottom: 10px;
}

.doctor_pic {
    width: 60.87px !important;
    height: 60.87px;
    object-fit: contain;
    border-radius: 100px;
}

.doctor_right_view {
    margin-left: 13.5px;
}

.doctor_right_view h3 {
    font-size: 20px;
    line-height: 28px;
    color: #294859;
    font-family: 'Lora-Regular';
    padding-bottom: 5px;
}

.doctor_right_view p {
    font-size: 14px;
    line-height: 20px;
    color: #294859;
    font-family: 'PublicSans-Regular';
}

.card-content p {
    font-size: 12px;
    line-height: 18px;
    color: #294859;
    font-family: 'PublicSans-Regular';
    padding-bottom: 18px;
}

.slectbtn {
    background-color: #FFFFFF;
    padding: 6px 34px;
    border: 1px solid #294859;
    border-radius: 100px;
    font-size: 16px;
    line-height: 25px;
    font-family: 'PublicSans-Regular';
    color: #294859;
    width: 155px;
}

.slectbtn:hover {
    background-color: #edc35a !important;
    color: #FFFFFF;
    border: 1px solid #edc35a;
}

.activebtn {
    background-color: #edc35a !important;
    color: #FFFFFF;
    border: 1px solid #edc35a;
}

.active-card {
    border: 1px solid #294859;
}`, "",{"version":3,"sources":["webpack://./src/components/DoctorCard/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".card-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    flex: 1;\n}\n\n.card-topview {\n    display: flex;\n    flex-direction: row;\n    padding-bottom: 10px;\n}\n\n.doctor_pic {\n    width: 60.87px !important;\n    height: 60.87px;\n    object-fit: contain;\n    border-radius: 100px;\n}\n\n.doctor_right_view {\n    margin-left: 13.5px;\n}\n\n.doctor_right_view h3 {\n    font-size: 20px;\n    line-height: 28px;\n    color: #294859;\n    font-family: 'Lora-Regular';\n    padding-bottom: 5px;\n}\n\n.doctor_right_view p {\n    font-size: 14px;\n    line-height: 20px;\n    color: #294859;\n    font-family: 'PublicSans-Regular';\n}\n\n.card-content p {\n    font-size: 12px;\n    line-height: 18px;\n    color: #294859;\n    font-family: 'PublicSans-Regular';\n    padding-bottom: 18px;\n}\n\n.slectbtn {\n    background-color: #FFFFFF;\n    padding: 6px 34px;\n    border: 1px solid #294859;\n    border-radius: 100px;\n    font-size: 16px;\n    line-height: 25px;\n    font-family: 'PublicSans-Regular';\n    color: #294859;\n    width: 155px;\n}\n\n.slectbtn:hover {\n    background-color: #edc35a !important;\n    color: #FFFFFF;\n    border: 1px solid #edc35a;\n}\n\n.activebtn {\n    background-color: #edc35a !important;\n    color: #FFFFFF;\n    border: 1px solid #edc35a;\n}\n\n.active-card {\n    border: 1px solid #294859;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
